export default __webpack_public_path__ + "static/media/event-img.e1c8986d.png";